module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__top"
  }, [_c('ul', {
    staticClass: "footer__list"
  }, _vm._l((_vm.$lang.footer.menu), function(footerLink) {
    return _c('li', {
      staticClass: "footer__list--item"
    }, [_c('a', {
      staticClass: "footer__list--item-link",
      attrs: {
        "href": footerLink.link
      }
    }, [_vm._v(_vm._s(footerLink.title))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "footer__bottom"
  }, [_c('div', {
    staticClass: "footer__bottom--text"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "footer__bottom--span"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.footer.text.first) + "\n          "), _c('a', {
    staticClass: "footer__bottom--link full",
    attrs: {
      "href": _vm.$lang.footer.text.PSNC.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PSNC.full))]), _vm._v(" "), _c('a', {
    staticClass: "footer__bottom--link short",
    attrs: {
      "href": _vm.$lang.footer.text.PSNC.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PSNC.short))])]), _vm._v(" "), _c('span', {
    staticClass: "footer__bottom--span"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.footer.text.second) + "\n          "), _c('a', {
    staticClass: "footer__bottom--link full",
    attrs: {
      "href": _vm.$lang.footer.text.PIONIER.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PIONIER.full))]), _vm._v(" "), _c('a', {
    staticClass: "footer__bottom--link short",
    attrs: {
      "href": _vm.$lang.footer.text.PIONIER.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PIONIER.short))])])]), _vm._v(" "), _c('p', {
    staticClass: "footer__bottom--partners"
  }, [_c('a', {
    staticClass: "footer__bottom--partners-link",
    attrs: {
      "href": _vm.$lang.footer.text.PSNC.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/footer__pcss.png",
      "title": _vm.$lang.footer.text.PSNC.full
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "footer__bottom--partners-link",
    attrs: {
      "href": _vm.$lang.footer.text.PIONIER.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/footer__pionier.png",
      "title": _vm.$lang.footer.text.PIONIER.full
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "footer__bottom--img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/footer__fbc.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50047dc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Footer.vue
// module id = 339
// module chunks = 1